/* eslint-disable @typescript-eslint/no-var-requires */
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import UIApplication from 'UIComponents/app/UIApplication';
import { AppProvider as TrellisAppProvider } from 'trellis-components/components/AppProvider';
// @ts-expect-error untyped loader
import { name as packageName } from 'current-package-loader!';
import { renderAppRoot } from 'quartz-core/internal/root-renderer';
import { initializeI18n } from 'quartz-i18n/initialize';
import { getQuartzConfig } from 'quartz-config/evaluable';
import { invariant } from 'quartz/invariant';
import { I18nHMRProvider } from 'I18n/components/I18nHMRProvider';
import { initializeTracking } from 'quartz-tracking/initialize';
import getLang from 'I18n/utils/getLang';
import { mark } from './perf';
import registerAllPublicData from 'I18n/init/register/sync/registerAllPublicData';
import { isPromiseLike } from './isPromiseLike';
import quartzCoreLang from 'i2l?sync&query=sporks!../../lang/en.lyaml';
import { Metrics } from './metrics';
import { jsx as _jsx } from "react/jsx-runtime";
export async function renderApp({
  prepareApp,
  AppComponent,
  getLocaleInfo
}, {
  lang,
  container
}) {
  var _result$onAfterRender;
  const quartzConfig = getQuartzConfig();
  /* invariant(quartzConfig.type === 'application' && quartzConfig.auth === 'none') */
  ;
  const {
    htmlTitleLangKey
  } = quartzConfig;
  const localeInfoResult = getLocaleInfo === null || getLocaleInfo === void 0 ? void 0 : getLocaleInfo();
  const localeInfo = isPromiseLike(localeInfoResult) ? await localeInfoResult : localeInfoResult;
  const [result] = await Promise.all([prepareApp(), initializeI18n({
    langs: [lang, quartzCoreLang],
    createPublicProvider: true,
    registerFn: registerAllPublicData,
    localeInfo,
    trackSetLocale: () => {
      Metrics.counter('i18n_setLocale_called').increment();
    }
  })]);
  initializeTracking({
    lang: getLang(),
    email: null,
    hstc: null,
    hubId: null
  });
  mark('quartz.prepareAppFinished');
  if (htmlTitleLangKey) {
    setDocumentTitle(htmlTitleLangKey);
  }
  if (result && 'redirect' in result) {
    throw new Error('[srcdoc mode] prepareApp() returned a redirect, which is not supported in srcdoc mode.');
  }
  await renderAppRoot( /*#__PURE__*/_jsx(UIApplication, {
    name: packageName,
    children: /*#__PURE__*/_jsx(TrellisAppProvider, {
      children: /*#__PURE__*/_jsx(I18nHMRProvider, {
        children: /*#__PURE__*/_jsx(AppComponent, Object.assign({}, result === null || result === void 0 ? void 0 : result.props))
      })
    })
  }), {
    legacyRoot: quartzConfig.createRootApi === false || quartzConfig.createRootApi === 'tests-only',
    strictMode: quartzConfig.reactStrictMode,
    container
  });
  result === null || result === void 0 || (_result$onAfterRender = result.onAfterRender) === null || _result$onAfterRender === void 0 || _result$onAfterRender.call(result);
  if ( /* 'plugins' in quartzConfig */false) {
    const {
      getAppExtensions
    } = require('./plugins/app-plugins');
    for (const plugin of getAppExtensions()) {
      plugin.hooks.onAfterRender();
    }
  }
}